import { Link } from 'react-router-dom';
import { ChefHat, Mail } from 'lucide-react';

export const CONTACT_EMAIL = 'masalaspin@erkupaetta.resend.app';

/** Site-wide footer with full navigation, contact and policy links. */
export const SiteFooter = () => (
  <footer
    className="py-14 px-6 border-t border-[#1C1917]/10"
    style={{ background: '#FDFBF7' }}
    data-testid="site-footer"
  >
    <div className="max-w-6xl mx-auto">
      <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-4">
        <div>
          <div className="flex items-center gap-2.5 mb-3">
            <ChefHat className="w-6 h-6 text-[#F97316]" aria-hidden="true" />
            <span className="font-['Playfair_Display'] text-lg font-bold text-[#1C1917]">
              Masala Spin
            </span>
          </div>
          <p className="text-sm text-[#1C1917]/60 font-['Outfit'] leading-relaxed">
            A free Indian recipe site with a spin-the-wheel picker, regional recipe collections,
            a weekly meal planner and long-form cooking guides.
          </p>
        </div>

        <div>
          <h2 className="text-xs uppercase tracking-widest text-[#F97316] font-['Outfit'] font-semibold mb-4">
            Explore
          </h2>
          <ul className="space-y-2.5 text-sm font-['Outfit']">
            <li><Link to="/" data-testid="footer-home" className="text-[#1C1917]/65 hover:text-[#F97316] transition-colors">Home</Link></li>
            <li><a href="/#meal-spinner" data-testid="footer-recipes" className="text-[#1C1917]/65 hover:text-[#F97316] transition-colors">Recipes &amp; recipe wheel</a></li>
            <li><a href="/#cuisines" data-testid="footer-cuisines" className="text-[#1C1917]/65 hover:text-[#F97316] transition-colors">Regional cuisines</a></li>
            <li><Link to="/blog" data-testid="footer-blog" className="text-[#1C1917]/65 hover:text-[#F97316] transition-colors">Recipe Blog</Link></li>
            <li><Link to="/challenge" data-testid="footer-challenge" className="text-[#1C1917]/65 hover:text-[#F97316] transition-colors">21-Day Meal Plan</Link></li>
          </ul>
        </div>

        <div>
          <h2 className="text-xs uppercase tracking-widest text-[#F97316] font-['Outfit'] font-semibold mb-4">
            Site
          </h2>
          <ul className="space-y-2.5 text-sm font-['Outfit']">
            <li><Link to="/about" data-testid="footer-about" className="text-[#1C1917]/65 hover:text-[#F97316] transition-colors">About</Link></li>
            <li><Link to="/contact" data-testid="footer-contact" className="text-[#1C1917]/65 hover:text-[#F97316] transition-colors">Contact</Link></li>
            <li><Link to="/privacy-policy" data-testid="footer-privacy" className="text-[#1C1917]/65 hover:text-[#F97316] transition-colors">Privacy Policy</Link></li>
            <li><Link to="/terms" data-testid="footer-terms" className="text-[#1C1917]/65 hover:text-[#F97316] transition-colors">Terms of Use</Link></li>
            <li><Link to="/contact?topic=recipe-submission" data-testid="footer-submit-recipe" className="text-[#1C1917]/65 hover:text-[#F97316] transition-colors">Submit a Recipe</Link></li>
          </ul>
        </div>

        <div>
          <h2 className="text-xs uppercase tracking-widest text-[#F97316] font-['Outfit'] font-semibold mb-4">
            Get in touch
          </h2>
          <a
            href={`mailto:${CONTACT_EMAIL}`}
            data-testid="footer-email"
            className="inline-flex items-start gap-2 text-sm font-['Outfit'] text-[#1C1917]/65 hover:text-[#F97316] transition-colors break-all"
          >
            <Mail className="w-4 h-4 mt-0.5 flex-shrink-0" aria-hidden="true" />
            {CONTACT_EMAIL}
          </a>
          <p className="text-xs text-[#1C1917]/50 font-['Outfit'] mt-4 leading-relaxed">
            Recipe corrections, nutrition corrections, copyright concerns and advertising
            enquiries are all welcome.
          </p>
        </div>
      </div>

      <div className="mt-12 pt-6 border-t border-[#1C1917]/10 flex flex-col sm:flex-row gap-3 justify-between items-start sm:items-center">
        <p className="text-xs text-[#1C1917]/45 font-['Outfit'] max-w-2xl leading-relaxed">
          Cooking times and calorie figures on Masala Spin are estimates for general information
          only and are not nutritional or medical advice.
        </p>
        <p className="text-xs text-[#1C1917]/45 font-['Outfit'] whitespace-nowrap">
          © {new Date().getFullYear()} Masala Spin
        </p>
      </div>
    </div>
  </footer>
);
